import ExcelJS from "exceljs";

const EXCLUDE_LIST = ["shivera_lifestyle_private_limited", "kj_lifestyle_llp_ap", "kj_lifestyle_llp_ts"];
// apply overall border
function applyOuterBorder(sheet, startRow, endRow, startCol, endCol) {
	for (let row = startRow; row <= endRow; row++) {
		for (let col = startCol; col <= endCol; col++) {
			const cell = sheet.getCell(row, col);
			const existing = cell.border || {};

			cell.border = {
				top: row === startRow ? { style: "medium" } : existing.top,
				bottom: row === endRow ? { style: "medium" } : existing.bottom,
				left: col === startCol ? { style: "medium" } : existing.left,
				right: col === endCol ? { style: "medium" } : existing.right,
			};
		}
	}
}

// save and download the file
const saveExcelFile = (buffer, fileName) => {
	// Create a Blob from the buffer
	const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
	// Create a download link
	const downloadLink = document.createElement("a");
	downloadLink.href = window.URL.createObjectURL(blob);
	downloadLink.download = fileName;
	// Trigger download
	downloadLink.click();
};

export const modifyExcel = async (data, name, headerData, franchise) => {
	const workbook = new ExcelJS.Workbook();
	const sheet = workbook.addWorksheet("Commission Report");

	// Colors
	const headerFill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFDAEEF3" } };
	const subHeaderFill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFEEFAD9" } };
	const borderStyle = {
		top: { style: "thin" },
		left: { style: "thin" },
		bottom: { style: "thin" },
		right: { style: "thin" },
	};

	// Helper for setting styles
	const styleCells = (range) => {
		range.eachCell((cell) => {
			cell.fill = subHeaderFill;
			cell.border = borderStyle;
			cell.alignment = { vertical: "middle", horizontal: "center" };
			cell.font = { bold: true };
		});
	};

	// Title
	sheet.mergeCells("C3", "Q3");
	sheet.getCell("C3").value = `${name} - COMMISSION WORKING ${headerData}`;
	sheet.getCell("C3").alignment = { horizontal: "center" };
	sheet.getCell("C3").font = { size: 14, bold: true };
	sheet.getCell("C3").fill = {
		type: "pattern",
		pattern: "solid",
		fgColor: { argb: "B8CCE4" },
	};

	// Sub Title
	sheet.mergeCells("C4", "Q4");
	sheet.getCell("C4").value = `Month ${headerData}`;
	sheet.getCell("C4").alignment = { horizontal: "center" };
	sheet.getCell("C4").font = { bold: true };

	// === Section 1: Commission Table ===
	const commissionHeaders = [
		"Month",
		"Store Name",
		"City",
		"Qty.",
		"MRP Sales",
		"Discount",
		"Discount %",
		"Realised Sales",
		"Commission on Realised",
		"Commission Value",
		"Salary Deduction",
		"Petty Cash",
		"Net Commission",
		"GST",
		"Total Value",
	];

	const startRow = 5;
	const startCol = 3; // Column C = 3

	// Write Headers at C5
	commissionHeaders.forEach((header, index) => {
		sheet.getCell(startRow, startCol + index).value = header;
		sheet.getCell(startRow, startCol + index).fill = {
			type: "pattern",
			pattern: "solid",
			fgColor: { argb: "EBF1DE" },
		};
		sheet.getCell(startRow, startCol + index).font = { bold: true };
		sheet.getCell(startRow, startCol + index).border = {
			top: { style: "thin" },
			left: { style: "thin" },
			bottom: { style: "thin" },
			right: { style: "thin" },
		};
	});
	sheet.getCell(startCol, startRow);
	// sheet.addRow(commissionHeaders);
	styleCells(sheet.getRow(6));

	let totalQty = 0,
		totalMrp = 0,
		totalDiscount = 0,
		totalRealised = 0,
		totalCommissionVal = 0,
		totalSalaryDed = 0,
		totalPetty = 0,
		totalNet = 0,
		totalGst = 0,
		totalValue = 0;

	data.forEach((item, rowIndex) => {
		const currentRow = sheet.getRow(startRow + 1 + rowIndex); // C5, C6,
		const net_value = EXCLUDE_LIST.includes(franchise) ? item?.COMISSION_VALUE : "-";
		const gst_value = EXCLUDE_LIST.includes(franchise) ? item?.COMISSION_VALUE * (18 / 100) : "-";
		let total_value = "-";
		if (gst_value !== "-" && gst_value !== "-") {
			total_value = gst_value + net_value;
		}

		const values = [
			headerData || "",
			item.STORE_NAME,
			item.CITY,
			item.BILL_QUANTITY,
			item.MRP_VALUE,
			item.TOTAL_DISCOUNT,
			`${item.DISCOUNT_PERCENT}`,
			item.REALISED_VALUE,
			`${item.COMISSION_RATE}`,
			item?.COMISSION_VALUE,
			item?.salary_deduction || "-",
			item?.petty_cash?.amount || "-",
			net_value,
			gst_value,
			total_value,
		];
		values.forEach((val, colIndex) => {
			currentRow.getCell(startCol + colIndex).value = val;
			currentRow.getCell(startCol + colIndex).border = {
				top: { style: "thin" },
				left: { style: "thin" },
				bottom: { style: "thin" },
				right: { style: "thin" },
			};
		});

		totalQty += item.BILL_QUANTITY;
		totalMrp += item.MRP_VALUE;
		totalDiscount += item.TOTAL_DISCOUNT;
		totalRealised += item.REALISED_VALUE;
		totalCommissionVal += item.COMISSION_VALUE;
		totalSalaryDed = "-";
		totalPetty = "-";
		// totalNet = "-";
		// totalGst = "-";
		// totalValue = "-";
		// totalSalaryDed += item.salary_deduction;
		// totalPetty += typeof item?.petty_cash?.amount === "number" ? item?.petty_cash?.amount : 0;
		totalSalaryDed = "-";
		totalPetty = "-";
		if (EXCLUDE_LIST.includes(franchise)) {
			totalNet += net_value;
			totalGst += gst_value;
			totalValue += total_value;
		} else {
			totalNet += typeof net_value === "number" ? net_value : 0;
			totalGst += typeof gst_value === "number" ? gst_value : 0;
			totalValue += typeof totalValue === "number" ? totalValue : 0;
		}
	});

	// Add total row
	const totalRow = sheet.getRow(startRow + 2 + data.length); // Just after last data row
	// totalRow.fill = {
	// 	type: "pattern",
	// 	pattern: "solid",
	// 	fgColor: { argb: "DAEEF3" },
	// };
	// totalRow.font = { bold: true };
	const totalValues = [
		"Total",
		"",
		"",
		totalQty,
		totalMrp,
		totalDiscount,
		"",
		totalRealised,
		"",
		totalCommissionVal,
		totalSalaryDed,
		totalPetty,
		totalNet,
		totalGst,
		totalValue,
	];

	totalValues.forEach((val, colIndex) => {
		totalRow.getCell(startCol + colIndex).value = val;
		totalRow.getCell(startCol + colIndex).fill = {
			type: "pattern",
			pattern: "solid",
			fgColor: { argb: "DAEEF3" },
		};
		totalRow.getCell(startCol + colIndex).font = {
			bold: true,
		};
		totalRow.getCell(startCol + colIndex).border = {
			top: { style: "thin" },
			left: { style: "thin" },
			bottom: { style: "thin" },
			right: { style: "thin" },
		};
	});

	// === Section 2: Manpower Table ===
	const manpowerHeaders = [
		"Month",
		"Store Name",
		"City",
		"Earned Salary",
		"Incentive",
		"Employer ESI",
		"Employer PF",
		"Total Liability",
	];

	// Determine starting row for manpower section (1 row below totals)
	const manpowerStartRow = startRow + 3 + data.length + 1;

	// Write manpower headers at C(manpowerStartRow)
	manpowerHeaders.forEach((header, index) => {
		const cell = sheet.getCell(manpowerStartRow, startCol + index);
		cell.value = header;
		cell.fill = {
			type: "pattern",
			pattern: "solid",
			fgColor: { argb: "EBF1DE" },
		};
		cell.font = { bold: true };
		cell.border = {
			top: { style: "thin" },
			left: { style: "thin" },
			bottom: { style: "thin" },
			right: { style: "thin" },
		};
	});

	// Fill manpower rows
	data.forEach((item, rowIndex) => {
		const mp = item?.manpower;
		const currentRow = sheet.getRow(manpowerStartRow + 1 + rowIndex);
		const values = [
			// mp?.month || " ",
			// mp?.store_name || " ",
			headerData || " ",
			item?.STORE_NAME || " ",
			mp?.city || " ",
			mp?.earned_salary || " ",
			mp?.incentive || " ",
			mp?.employer_esi || " ",
			mp?.employer_pf || " ",
			mp?.total_liability || " ",
		];

		values.forEach((val, colIndex) => {
			currentRow.getCell(startCol + colIndex).value = val;
			currentRow.getCell(startCol + colIndex).border = {
				top: { style: "thin" },
				left: { style: "thin" },
				bottom: { style: "thin" },
				right: { style: "thin" },
			};
		});
	});

	// Add manpower totals
	const totalManpowerRow = sheet.getRow(manpowerStartRow + 1 + data.length);
	const manpowerTotals = [
		"Total",
		"",
		"",
		// data.reduce((sum, i) => sum + i.manpower?.earned_salary, 0),
		// data.reduce((sum, i) => sum + i.manpower?.incentive, 0),
		// data.reduce((sum, i) => sum + i.manpower?.employer_esi, 0),
		// data.reduce((sum, i) => sum + i.manpower?.employer_pf, 0),
		// data.reduce((sum, i) => sum + i.manpower?.total_liability, 0),
		"",
		"",
		"",
		"",
		"",
	];

	manpowerTotals.forEach((val, colIndex) => {
		totalManpowerRow.getCell(startCol + colIndex).value = val;
		totalManpowerRow.getCell(startCol + colIndex).fill = {
			type: "pattern",
			pattern: "solid",
			fgColor: { argb: "DAEEF3" },
		};
		totalManpowerRow.getCell(startCol + colIndex).font = { bold: true };
		totalManpowerRow.getCell(startCol + colIndex).border = {
			top: { style: "thin" },
			left: { style: "thin" },
			bottom: { style: "thin" },
			right: { style: "thin" },
		};
	});

	// // === Section 3: Petty Cash Table ===
	const pettyHeaders = ["Month", "Store Name", "Amount"];

	// Place beside manpower: startCol + 9 = 3 + 9 = 12 → column "L"
	const pettyStartCol = startCol + 9;
	const pettyStartRow = manpowerStartRow; // Same top row as manpower section

	// Write petty cash headers at L[manpowerStartRow]
	pettyHeaders.forEach((header, index) => {
		const cell = sheet.getCell(manpowerStartRow, pettyStartCol + index);
		cell.value = header;
		cell.fill = {
			type: "pattern",
			pattern: "solid",
			fgColor: { argb: "EBF1DE" },
		};
		cell.font = { bold: true };
		cell.border = {
			top: { style: "thin" },
			left: { style: "thin" },
			bottom: { style: "thin" },
			right: { style: "thin" },
		};
	});

	// Fill petty cash rows
	data.forEach((item, rowIndex) => {
		const petty = item.petty_cash;
		const currentRow = sheet.getRow(manpowerStartRow + 1 + rowIndex);
		const values = [headerData || " ", petty?.store_name || " ", petty?.amount || " "];

		values.forEach((val, colIndex) => {
			currentRow.getCell(pettyStartCol + colIndex).value = val;
			currentRow.getCell(pettyStartCol + colIndex).border = {
				top: { style: "thin" },
				left: { style: "thin" },
				bottom: { style: "thin" },
				right: { style: "thin" },
			};
		});
	});

	// Add petty total row aligned with the others
	const totalPettyRow = sheet.getRow(manpowerStartRow + 1 + data.length);
	// const pettyTotal = data.reduce((sum, i) => sum + i?.petty_cash.amount, 0); // Keep this for next version use.
	const pettyTotal = " ";
	const pettyTotalValues = ["Total", "", pettyTotal];

	pettyTotalValues.forEach((val, colIndex) => {
		totalPettyRow.getCell(pettyStartCol + colIndex).value = val;
		totalPettyRow.getCell(pettyStartCol + colIndex).fill = {
			type: "pattern",
			pattern: "solid",
			fgColor: { argb: "DAEEF3" },
		};
		totalPettyRow.getCell(pettyStartCol + colIndex).font = { bold: true };
		totalPettyRow.getCell(pettyStartCol + colIndex).border = {
			top: { style: "thin" },
			left: { style: "thin" },
			bottom: { style: "thin" },
			right: { style: "thin" },
		};
	});

	// === Footer: Prepared / Approved By ===
	let footerRow = pettyStartRow + 4 + data.length;
	sheet.getRow(footerRow).getCell(5).value = "Prepared By";
	sheet.getRow(footerRow).getCell(10).value = "Approved By";
	sheet.getRow(footerRow).getCell(15).value = "Approved By";

	sheet.getRow(footerRow + 2).getCell(5).value = "Varun Mishra";
	sheet.getRow(footerRow + 2).getCell(10).value = "Bhavish Kumar";
	sheet.getRow(footerRow + 2).getCell(15).value = "Lavish Soni";

	// Column Widths
	sheet.columns.forEach((col) => {
		col.width = 14;
	});

	const outerStartRow = startRow - 2; // e.g., 4 (C4 where Commission headers begin)
	const outerEndRow = footerRow + 3;

	const outerStartCol = startCol; // usually 3 (column C)
	const outerEndCol = 17; // add 17

	applyOuterBorder(sheet, outerStartRow, outerEndRow, outerStartCol, outerEndCol);

	// Generate Excel file as a Buffer
	const buffer = await workbook.xlsx.writeBuffer();

	// Save the Excel file
	saveExcelFile(buffer, `${name}-summary.xlsx`);
	console.log("Excel file generated: commission_report.xlsx");
};
